import React from "react"
import { splitOnMdxType } from "../../utils/mdxTypeUtils"
import style from "./Layout.module.scss"
import Layout from "../../components/layouts/Layout"

export default ({ children }) => {
  const [ intro, ...tiers ] = splitOnMdxType('h2', children)
  return (
    <Layout>
      <section className={style.container}>
        {intro}
      </section>
      <section className={style.prices}>
        {tiers.map((tier, i) => (
          <article kay={i}>
            <div>
              {tier}
            </div>
          </article>
        ))}
      </section>
    </Layout>
  )
}
